<template>
  <div id="app" :class="[theme === 'dark' ? 'dark-theme' : 'light-theme']">
    <div class="cyber-bg" v-if="theme === 'dark'">
      <div class="grid-overlay"></div>
    </div>

    <div class="content-wrapper">
      <header class="main-header">
        <div class="brand">
          <h1 class="logo-text">3-KEY <span class="highlight">电子积木</span></h1>
        </div>
        
        <div class="header-right-group">
          <div class="control-item theme-toggle" @click="toggleTheme">
            <i v-if="theme === 'dark'" class="el-icon-sunny"></i>
            <i v-else class="el-icon-moon"></i>
          </div>
          <div class="control-item lang-switch">
            <span :class="{active: $i18n.locale==='zh'}" @click="changeLang('zh')">ZH</span>
            <span class="sep">/</span>
            <span :class="{active: $i18n.locale==='en'}" @click="changeLang('en')">EN</span>
          </div>
          <div class="control-item help-trigger">
            <i class="el-icon-question" @click="showHelp"></i>
          </div>
        </div>
      </header>

      <section class="action-bar">
        <el-button type="primary" class="btn-cyber-narrow" @click="connect()" :loading="btnLoading">
          <i class="el-icon-connection"></i> {{ $t('index.connButtonText1') }}
        </el-button>
      </section>

      <main class="config-stack">
        <div class="key-card" v-for="n in 3" :key="n">
          <div class="card-tag">KEY_0{{ n }}</div>
          <div class="card-body">
            <key-config 
              :keyname="''" 
              :keymode.sync="n==1?key1:n==2?key2:key3" 
              :keyfunc.sync="n==1?key1func:n==2?key2func:key3func" 
              :keyf.sync="n==1?key1f:n==2?key2f:key3f" 
              :keymix.sync="n==1?key1mix:n==2?key2mix:key3mix" 
              :keystr.sync="n==1?key1str:n==2?key2str:key3str">
            </key-config>
          </div>
        </div>
      </main>

      <section class="extra-settings">
        <div class="glass-bar">
          <span class="label">3键同时按下时,作为独立按键</span>
          <el-switch v-model="keyallmode_bool" active-color="#00d2ff"></el-switch>
        </div>
        <div v-if="keyallmode_bool" class="batch-panel">
           <key-config :keyname="''" :keymode.sync="keyall" :keyfunc.sync="keyallfunc" :keyf.sync="keyallf" :keymix.sync="keyallmix" :keystr.sync="keyallstr" :stringshow="false"></key-config>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import KeyConfig from './components/KeyConfig.vue'

export default {
  name: 'app',
  components: { KeyConfig },
  data() {
    return {
      theme: 'dark',
      btnLoading: false,
      device: null,
      key1:0xff, key2:0xff, key3:0xff,
      key1func:0xff, key2func:0xff, key3func:0xff,
      key1f:0xff, key2f:0xff, key3f:0xff,
      key1str:'', key2str:'', key3str:'',
      key1mix:[0xff,0xff,0xff,0xff,0xff],
      key2mix:[0xff,0xff,0xff,0xff,0xff],
      key3mix:[0xff,0xff,0xff,0xff,0xff],
      keyall:0xff, keyallfunc:0xff, keyallf:0xff, keyallstr:'',
      keyallmix:[0xff,0xff,0xff,0xff,0xff],
      keyallmode_bool: false
    }
  },
  methods: {
    toggleTheme() { this.theme = this.theme === 'dark' ? 'light' : 'dark'; },
    changeLang(lang) { this.$i18n.locale = lang; localStorage.setItem('lang', lang); },
    showHelp() {
      this.$alert(this.$t('index.helpTips0'), this.$t('index.helpTitle'));
    },
    async connect() {
      this.btnLoading = true;
      try {
        const devices = await navigator.hid.requestDevice({ 
          filters: [{ vendorId: 0x413d }, { vendorId: 0x2107 }] 
        });
        if (devices.length > 0) {
          this.device = devices[0];
          await this.device.open();
          this.$message.success("SYNC OK");
        }
      } catch (e) { this.$message.error("CANCELLED"); } finally { this.btnLoading = false; }
    }
  }
}
</script>

<style>
/* --- 基础样式 --- */
#app { min-height: 100vh; padding: 20px; transition: 0.3s ease; font-family: 'Segoe UI', sans-serif; }
.dark-theme { background: #05080a; color: #00d2ff; }
.light-theme { background: #f5f7fa; color: #333; }
.content-wrapper { max-width: 800px; margin: 0 auto; position: relative; z-index: 5; }

/* --- 科技感元素 --- */
.grid-overlay {
  position: fixed; top: 0; left: 0; width: 100%; height: 100%;
  background-image: linear-gradient(rgba(0, 210, 255, 0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(0, 210, 255, 0.05) 1px, transparent 1px);
  background-size: 30px 30px; pointer-events: none;
}

/* --- Header 对齐 --- */
.main-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 25px; border-bottom: 1px solid rgba(0,210,255,0.2); padding-bottom: 10px; }
.header-right-group { display: flex; align-items: center; gap: 20px; }
.control-item { cursor: pointer; display: flex; align-items: center; font-size: 14px; }
.theme-toggle { font-size: 18px; color: #00d2ff; }
.lang-switch span.active { font-weight: bold; text-decoration: underline; }
.help-trigger { font-size: 18px; opacity: 0.8; }

/* --- 窄按钮 --- */
.action-bar { text-align: center; margin-bottom: 30px; }
.btn-cyber-narrow { width: 180px !important; border-radius: 4px !important; font-weight: bold !important; }

/* --- 模块排版 (垂直) --- */
.config-stack { display: flex; flex-direction: column; gap: 20px; }
.key-card { 
  background: rgba(255,255,255,0.02); border: 1px solid rgba(0,210,255,0.2); 
  border-radius: 4px; padding: 20px; position: relative;
}
.light-theme .key-card { background: #fff; border-color: #ddd; box-shadow: 0 2px 8px rgba(0,0,0,0.05); }
.card-tag { font-size: 10px; color: #00d2ff; font-weight: bold; margin-bottom: 10px; opacity: 0.6; }

/* --- 强制选项不分行 --- */
.el-radio-group { display: flex !important; flex-wrap: nowrap !important; overflow-x: auto; padding-bottom: 5px; }
.el-radio { flex-shrink: 0; margin-right: 15px !important; }

/* --- 精准解决 undefined --- */
/* 我们不隐藏 label，而是将 label 中那个多余的文字隐藏 */
/* 假设 KeyConfig 内部结构是 <label>undefined:</label> */
.el-form-item__label, .key-config-label { 
  text-indent: -9999px; /* 移出屏幕 */
  width: 0; 
  display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/App.vue